/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { inject, observer } from "mobx-react";
import FloatingWindowComponent from "components/FloatingWindow/FloatingWindowComponent";
import { getCurrentPageIndex } from "selectors/pageNumber";
import { getDocumentViewHandle, getViewPortHeight, getViewPortWidth } from "selectors/documentViewSelectors";
import {
  calculateNewPosition,
  careRectBoundary,
  getWindowPositionToRender,
  getRectsInPreviewViewSpace,
  getPositionFromTargetPointInViewSpace
} from "utils/floatingWindowUtils";
import FloatingWindowsManagerInstance from "FloatingWindow/FloatingWindowsManager";
import { getPagesViewElementHandle } from "selectors/pagedViewState";

const mapStoreToProps = (stores, ownProps) => ({
  ...ownProps,
  getPagesViewElementHandle: () => getPagesViewElementHandle(stores),
  documentViewPortHeight: getViewPortHeight(stores),
  documentViewPortWidth: getViewPortWidth(stores),
  docViewRects: getDocumentViewHandle(stores)?.getBoundingClientRect(),
  getWindowPositionToRender: (target, window, margin, positionPriority) =>
    getWindowPositionToRender(stores, target, window, margin, positionPriority),
  getRectsInPreviewViewSpace: rect => getRectsInPreviewViewSpace(stores, rect),
  calculateNewPosition: (initialCursorPos, finalCursorPos, prevFloatingWindowPosition, windowDimensions) =>
    calculateNewPosition(stores, initialCursorPos, finalCursorPos, prevFloatingWindowPosition, windowDimensions),
  getPositionFromTargetPointInViewSpace,
  careRectBoundary
});

const FloatingWindowsMapper = observer(props => (
  <>
    {FloatingWindowsManagerInstance.getAllWindowInstances().map(floatingWindow => (
      <FloatingWindowComponent key={floatingWindow.windowId} id={floatingWindow.windowId} {...props} />
    ))}
  </>
));

const FloatingWindowContainer = inject(mapStoreToProps)(FloatingWindowsMapper);

export default FloatingWindowContainer;
